import React from "react";
import {Pagination} from "react-bootstrap";

export default function PaginationBar({pageCount, activePage, onSelect}) {
    const offsetButtons = 2;
    activePage = Math.max(activePage, 1);
    activePage = Math.min(activePage, pageCount);
    let firstPageNumber = Math.max(1, activePage - offsetButtons);
    let lastPageNumber = Math.min(pageCount, activePage + offsetButtons);

    let pageItems = [];

    for (let i = firstPageNumber; i <= lastPageNumber; i++) {
        pageItems.push(
            <Pagination.Item
                active={i === activePage}
                key={`page_${i}`}
                onClick={() => onSelect(i)}
            >{i}</Pagination.Item>
        );
    }

    return (
        <Pagination>
            <Pagination.First onClick={() => onSelect(1)} disabled={activePage <= 1} />
            <Pagination.Prev onClick={() => onSelect(activePage - 1)} disabled={activePage <= 1} />
            {pageItems}
            <Pagination.Next onClick={() => onSelect(activePage + 1)} disabled={activePage >= pageCount} />
            <Pagination.Last onClick={() => onSelect(pageCount)} disabled={activePage >= pageCount} />
        </Pagination>
    );
}
